import { loadMessages, locale } from "devextreme/localization";
import localeMsg from "./localizeDevextreme.locale";
export default () => {
    loadMessages({
        ru: localeMsg
    });
    locale("ru");
};
